// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.errorPage {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  padding: 12px;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: center;
          justify-content: center;
  -webkit-align-items: center;
          align-items: center;
  -webkit-flex-direction: column;
          flex-direction: column;
  background-color: #dfe2e5;
}
.errorPage-img {
  width: 260px;
  height: 210px;
}
.errorPage-img-mobile {
  width: 2.6rem;
  height: 2.1rem;
}
.errorPage-text {
  font-size: 14px;
  color: #555;
  margin-top: 16px;
}
.errorPage-subText {
  font-size: 12px;
  color: #333;
  margin-top: 12px;
  width: 572px;
  line-height: 18px;
}
.errorPage-btn {
  margin-top: 32px;
}
`, "",{"version":3,"sources":["webpack://./src/runtime/views/NotFoundView.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EAAA,aAAA;EACA,+BAAA;UAAA,uBAAA;EACA,2BAAA;UAAA,mBAAA;EACA,8BAAA;UAAA,sBAAA;EACA,yBAAA;AACF;AAAE;EACE,YAAA;EACA,aAAA;AAEJ;AACE;EACE,aAAA;EACA,cAAA;AACJ;AAEE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAAJ;AAGE;EACE,eAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;AADJ;AAIE;EACE,gBAAA;AAFJ","sourcesContent":[".errorPage {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1;\n  width: 100%;\n  height: 100%;\n  padding: 12px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background-color: #dfe2e5;\n  &-img {\n    width: 260px;\n    height: 210px;\n  }\n\n  &-img-mobile {\n    width: 2.6rem;\n    height: 2.1rem;\n  }\n\n  &-text {\n    font-size: 14px;\n    color: #555;\n    margin-top: 16px;\n  }\n\n  &-subText {\n    font-size: 12px;\n    color: #333;\n    margin-top: 12px;\n    width: 572px;\n    line-height: 18px;\n  }\n\n  &-btn {\n    margin-top: 32px;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
